@if (viewMode === 'chips') {
  <div class="d-flex align-items-start">
    <div class="d-flex flex-1 flex-wrap gap-2" [ngClass]="{ 'me-2': appliedFilters.length > 0 }">
      @if (!isLoadingOptions) {
        @for (filter of appliedFilters; track filter; let i = $index) {
          <div
            class="badge filter-badge text-black bg-light d-flex align-items-center filterBadge"
            style="font-size: var(--fs-lg)"
            data-testid="filterChip"
            [ngbPopover]="addFilterPopover"
            placement="bottom-left"
            #filterPopover="ngbPopover"
            (click)="openPopover(filter)"
            [autoClose]="false"
            popoverClass="filterPopover"
          >
            <span class="me-1" data-cy="pharmacyFilter" data-testid="pharmacyFilter">{{ filter.display }}</span>
            @if (filter.icon) {
              <chitin-icon class="me-1" style="font-size: var(--fs-xs)" [icon]="filter.icon" />
            }
            @if (filter.iconText && !filter.iconTextPostfix) {
              <span class="me-1 iconTextSmall">{{ filter.iconText }}</span>
            }
            <span data-testid="filterChipValue">{{ filter.displayValue ?? filter.value }}</span>
            @if (filter.iconText && filter.iconTextPostfix) {
              <span>{{ filter.iconText }}</span>
            }
            @if (!filter.required) {
              <a class="ms-1" data-cy="removeFilter" data-testid="removeFilter" (click)="removeFilter(i)">
                <chitin-icon icon="fa-solid fa-xmark" />
              </a>
            }
            <ng-template #addFilterPopover>
              <div class="filterPopoverContainer">
                @if (activeFilter) {
                  <app-data-view-add-filter [model]="activeFilter" [activePopover]="filterPopover" (filterChanged)="filterEdited($event)" />
                }
              </div>
            </ng-template>
          </div>
        }
      }
      @if (isLoadingOptions) {
        <div class="spinner-border spinner-border-sm text-dark m-2 me-3" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      }
    </div>
    <div class="d-flex flex-shrink-0 gap-2">
      <chitin-button
        [disabled]="isLoadingOptions"
        (clicked)="addFilter()"
        color="secondary"
        icon="fa-solid fa-plus"
        label="Add filter"
        data-testid="addFilterBtn"
      />
      @if (showClearAll) {
        <chitin-button
          [disabled]="isLoadingOptions"
          (clicked)="clearAllClicked()"
          color="secondary"
          label="Clear all"
          data-cy="clearBtn"
          data-testid="clearBtn"
        />
      }
    </div>
  </div>
}

@if (viewMode === 'rows') {
  <div>
    @if (!isLoadingOptions) {
      <div>
        @for (filter of appliedFilters; track filter; let i = $index) {
          <div class="d-flex align-items-center gap-2 mb-2">
            <div>{{ filter.display }}</div>
            <app-data-view-add-filter style="flex-grow: 1" [model]="filter" (filterChanged)="filterEdited($event)" viewMode="row" />
            <a (click)="removeFilter(i)">
              <chitin-icon icon="fa-solid fa-xmark" />
            </a>
          </div>
        }
      </div>
    }
    @if (isLoadingOptions) {
      <div class="d-flex justify-content-center">
        <div class="spinner-border text-dark mt-2 mb-4" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    }
    <div class="d-flex gap-2">
      <chitin-button
        [disabled]="isLoadingOptions"
        (clicked)="addFilter()"
        color="secondary"
        icon="fa-solid fa-plus"
        label="Add filter"
        data-testid="addFilterBtn"
      />
      @if (appliedFilters.length > 0) {
        <chitin-button [disabled]="isLoadingOptions" (clicked)="clearAllClicked()" color="secondary" label="Clear all" />
      }
    </div>
  </div>
}
